// extracted by mini-css-extract-plugin
export var container = "_au-0";
export var icon = "_au-1";
export var text = "_au-2";